import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Deployment name (test / staging / production), baked in at build time from the GitHub
  // environment. Without it every build reports under the SDK default, "production" (VTK-1983).
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  integrations: [
    Sentry.captureConsoleIntegration({
      levels: ['error', 'warn'],
    }),
  ],
  // S5 (PII-leak hardening): never let Sentry auto-attach PII (IP, cookies, request data).
  // I-9 PII (SSN/DOB) must not reach Sentry — see the Section 1 IDOR remediation.
  sendDefaultPii: false,
  enabled: import.meta.env.PROD,
  enableLogs: true,
});
